/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';

export class Type extends Model {
  id: number;
  value: string;
  color: string;
  type: string;
  active: boolean;
  order_index: number;
  icon: string;
  real_value: string;

  /**
   *  Връща контрастен цвят. Използва се за да може да се чете текста.
   */
  get invertColor(): string {
    if (this.color) {
      return this.invColor(this.color);
    }
    return null;
  }

  /**
   *  Връща контрастен цвят.
   * https://stackoverflow.com/questions/35969656/how-can-i-generate-the-opposite-color-according-to-current-color
   * @param hex color
   * @param bw Boolean дали да го обръща към бяло или черно
   */
  private invColor(hex: string, bw: boolean = true): string {
    if (hex.indexOf('#') === 0) {
      hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
      throw new Error('Invalid HEX color.');
    }
    let r: any = parseInt(hex.slice(0, 2), 16),
      g: any = parseInt(hex.slice(2, 4), 16),
      b: any = parseInt(hex.slice(4, 6), 16);
    if (bw) {
      // http://stackoverflow.com/a/3943023/112731
      return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
    }
    // invert color components
    r = (255 - r).toString(16);
    g = (255 - g).toString(16);
    b = (255 - b).toString(16);
    // pad each with zeros and return
    return '#' + this.padZero(r) + this.padZero(g) + this.padZero(b);
  }

  private padZero(str: any, len: any = 2) {
    const zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
  }
}
